/* Scroll functions */
(function( $ ) {
    'use strict'

    /* Toggle scrolled state */
    $(document).on('scroll', function() {
        if ($(document).scrollTop() > 0) {
            $('body').addClass('scrolled')
        } else {
            $('body').removeClass('scrolled')
        }
    })

    $( '.module-herostage .content a' ).on( 'click', function() {
        $("html, body").animate({ scrollTop: $( '.module-usp' ).position().top })
        return false
    })
})( $ )
